export function teamSlider(root = document) {
    if (typeof window.Flickity !== 'function') return;

    const sliders = [];
    let disposed = false;
    root.querySelectorAll('[data-team-slider]').forEach((element) => {
        if (window.Flickity.data(element)) return;

        const slider = new window.Flickity(element, {
            cellSelector: '.featured-team__slide:not([hidden])',
            cellAlign: 'left',
            contain: true,
            groupCells: true,
            accessibility: true,
            prevNextButtons: element.children.length > 1,
            pageDots: false,
        });

        element.querySelector('.previous')?.setAttribute('aria-label', 'Vorige teamleden');
        element.querySelector('.next')?.setAttribute('aria-label', 'Volgende teamleden');

        sliders.push(slider);
        element.querySelectorAll('img').forEach((image) => {
            if (!image.complete) {
                image.addEventListener('load', () => { if (!disposed) slider.resize(); }, { once: true });
            }
        });

        document.fonts.ready.then(() => { if (!disposed) slider.resize(); });
    });
    return () => {
        disposed = true;
        sliders.forEach((slider) => slider.destroy());
    };
}
